import React from "react";
import "./BarChartTable.scss";
import { FormattedMessage } from "react-intl";

function BarChartLegend() {
  const renderLegend = (colorClass, messageId, defaultMessage) => (
    <div className="legend">
      <div className={`legend-color ${colorClass}`}></div>
      <FormattedMessage
        className="legend-text"
        id={messageId}
        defaultMessage={defaultMessage}
      />
    </div>
  );
  return (
    <div>
      <div className="legend-parent">
        {renderLegend("no-mission", "no_mission", "Aucun mission")}
        {renderLegend(
          "no-order-mission",
          "no_order_mission",
          "Pas de commande de prévue"
        )}
        {renderLegend(
          "futur-mission",
          "future_order_execution",
          "Exécution future de la commande"
        )}
        {renderLegend(
          "ongoing-mission",
          "mission_in_progress",
          "Mission en cours"
        )}
      </div>
    </div>
  );
}

export default BarChartLegend;
